module.exports = "/_next/static/images/5404183c031ca35fd1816397c482b542-open-graph-logo.png.webp";